module.exports = __webpack_public_path__ + "img/gashapon.75fe77fd.png";